import { connect } from 'react-redux';

import BuildPageChartContainer from './/BuildPageChartContainer.jsx';
import { getHitCountMetricsInfo } from './../reducers';

export const mapStateToProps = (state) => {
  const metricsInfo = getHitCountMetricsInfo(state);
  metricsInfo.metrics = metricsInfo.metrics.map(m => m.hitCountDiff);

  return {
    title: 'Hit Count Difference',
    metricsInfo
  };
};

export default connect(
  mapStateToProps
)(BuildPageChartContainer);


// WEBPACK FOOTER //
// src/Containers/HitCountChartContainer.jsx